<template>
  <v-card
    variant="outlined"
    class="d-flex flex-column align-center text-center pa-8"
    style="border-color: #eee; border-radius: 16px"
  >
    <img
      :src="item?.icon"
      :alt="item?.alt"
      width="80"
      height="80"
      loading="lazy"
      decoding="async"
    />
    <div class="text-h6 my-2 text-text-default">
      {{ lang(item?.label) }}
    </div>
    <div class="text-text-subdued">{{ lang(item?.desc) }}</div>
    <slot />
  </v-card>
</template>

<script>

export default {
  name: "ItemCard",
  props: {
    item: Object,
  },
};
</script>

<style scoped>
img {
  max-width: 80px;
  max-height: 80px;
  width: 100%;
  height: 100%;
  aspect-ratio: 1;
  object-fit: contain;
}
</style>
